import React from "react";
import "./style.css";
import Unibuilder from "../../assets/img/Unibuilder.png";
import Icon from "../Icon";
import useReveal from "../../hooks/useReveal";

const features = [
  "Project-wise data segregation",
  "Role-based access control",
  "Sub-domain architecture",
  "Secure cloud storage",
  "Reusable components",
  "Business-ready infrastructure",
];

export default function UnibuilderSpotlight() {
  const [visualRef, visualVisible] = useReveal();
  const [contentRef, contentVisible] = useReveal();

  return (
    <section className="unibuilder-spotlight">
      <div className="section-wrapper">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Column: Product Mockup */}
            <div className="col-lg-6">
              <div
                className={`mockup-wrapper reveal reveal--left ${
                  visualVisible ? "" : "is-hidden"
                }`}
                ref={visualRef}
              >
                <div className="mockup-glow" aria-hidden="true" />
                <div className="browser-frame">
                  <div className="browser-header">
                    <div className="browser-dots" aria-hidden="true">
                      <span className="dot dot--red" />
                      <span className="dot dot--amber" />
                      <span className="dot dot--green" />
                    </div>
                    <span className="browser-url" aria-hidden="true">
                      unibuilder.in
                    </span>
                  </div>
                  <div className="frame-content">
                    <img
                      src={Unibuilder}
                      alt="Unibuilder project dashboard"
                      className="frame-img"
                      width="600"
                      height="450"
                      loading="lazy"
                    />
                  </div>
                </div>

                <div className="mockup-badge">
                  <span
                    className="mockup-badge-dot pulse-dot"
                    aria-hidden="true"
                  />
                  Live in production
                </div>
              </div>
            </div>

            {/* Right Column: Text Content */}
            <div className="col-lg-6">
              <div
                className={`spotlight-content reveal reveal--right ${
                  contentVisible ? "" : "is-hidden"
                }`}
                ref={contentRef}
              >
                <span className="spotlight-eyebrow">
                  Unibuilder · Flagship Product
                </span>

                <h2 className="spotlight-title">
                  Ship role-based business apps{" "}
                  <span className="spotlight-title-accent">
                    without building a backend
                  </span>
                </h2>

                <p className="spotlight-description">
                  Project-scoped data, access control, and secure cloud storage
                  — configured, not coded. Your team ships features while
                  Unibuilder handles the infrastructure underneath.
                </p>

                <div className="features-grid reveal-stagger--fast">
                  {features.map((feature, index) => (
                    <div
                      key={feature}
                      className="feature-item"
                      style={{ "--stagger-index": index }}
                    >
                      <span className="feature-check" aria-hidden="true">
                        <Icon name="check" size={12} strokeWidth={3} />
                      </span>
                      <span className="feature-text">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="spotlight-buttons">
                  <a
                    className="btn btn-primary-custom"
                    href="https://unibuilder.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit Unibuilder
                    <Icon name="arrowRight" size={18} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
